import { render, staticRenderFns } from "./CardReviewFacility.vue?vue&type=template&id=67edb19a&scoped=true"
import script from "./CardReviewFacility.vue?vue&type=script&lang=js"
export * from "./CardReviewFacility.vue?vue&type=script&lang=js"
import style0 from "./CardReviewFacility.vue?vue&type=style&index=0&id=67edb19a&prod&lang=scss"
import style1 from "./CardReviewFacility.vue?vue&type=style&index=1&id=67edb19a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67edb19a",
  null
  
)

export default component.exports